import { LiteTextEditor } from "shared/app/Editor/LiteTextEditor";

interface NoteDisplayProps {
  note: string;
}

export const NoteDisplay = ({ note }: NoteDisplayProps) => {
  return (
    <LiteTextEditor
      editable={false}
      initialValue={note}
      id="activity-note"
      containerClassName="text-content-400 text-sm"
    />
  );
};
